import React from "react";

const CtaSection = ({ text = "Features", href = null, onClick }) => {
  return (
    <section
      data-w-id="69357659-14a0-5526-745f-0888c5cbe668"
      className="section cta"
    >
      <div className="container cta">
        <div className="cta-im-wrap">
          <div className="cta-black-arc"></div>
        </div>
        <a
          href={href}
          className="cta-link mbm-exclusion w-inline-block"
          target="_blank"
          onClick={onClick}
        >
          <div className="ball cta mbm-exclusion"></div>
          <div className="cta-txt mbm-exclusion">{text}</div>
        </a>
      </div>
    </section>
  );
};

export default CtaSection;
